import React from 'react'
import Form from 'react-bootstrap/Form'
import styled from 'styled-components'
import PropTypes from 'prop-types'
export default function FieldError(props) {
  const FeedBack = styled(Form.Control.Feedback)`
    display: block;
    text-align: ${props => props.theme.reverseDir};
  `
  const { message } = props
  return <FeedBack type="invalid">{message}</FeedBack>
}

FieldError.propTypes = {
  message: PropTypes.string,
}
